import { render, staticRenderFns } from "./MeuPortalBlocked.vue?vue&type=template&id=36adb52a&scoped=true&lang=pug"
import script from "./MeuPortalBlocked.vue?vue&type=script&lang=js"
export * from "./MeuPortalBlocked.vue?vue&type=script&lang=js"
import style0 from "./MeuPortalBlocked.vue?vue&type=style&index=0&id=36adb52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36adb52a",
  null
  
)

export default component.exports